import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-resources-board',
  templateUrl: './save-resources-board.component.html',
  styleUrls: ['./save-resources-board.component.scss']
})
export class SaveResourcesBoardComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<SaveResourcesBoardComponent>,
  ) { }

  ngOnInit(): void {
  }

  confirm(){
    this.dialogRef.close(true);
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
